import script from "./collapse.vue?vue&type=script&lang=ts&setup=true"
export * from "./collapse.vue?vue&type=script&lang=ts&setup=true"

import "./collapse.vue?vue&type=style&index=0&id=3317e24e&lang=scss"

const __exports__ = script;

export default __exports__